import { Suspense, lazy, useCallback } from "react";
import { useSelector } from "react-redux";

import { CatalogTabLayout } from "../../../../pages/catalogs/shared/components/catalog-tab-layout/catalog-tab-layout";
import { CATALOG_SECTIONS_ENUM } from "../../../../pages/catalogs/shared/components/catalog-tab-layout/catalog-tab-layout-types";
import { useAppDispatch } from "../../../../store";
import { getSearchText, setSearchText } from "../../store";

const TechAssetsTable = lazy(() => import("../tech-assets-table/tech-assets-table"));

const TechAssetsTab = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const searchText = useSelector(getSearchText);

  const onSearch = useCallback(
    (value: string) => dispatch(setSearchText(value)),
    [dispatch]
  );

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <CatalogTabLayout
        type={CATALOG_SECTIONS_ENUM.TECHNICKS}
        onSearch={onSearch}
        searchText={searchText}
      >
        <TechAssetsTable />
      </CatalogTabLayout>
    </Suspense>
  );
};

export default TechAssetsTab;
